import { render } from "./OneTab.vue?vue&type=template&id=0a761cf5&scoped=true"
import script from "./OneTab.vue?vue&type=script&lang=js"
export * from "./OneTab.vue?vue&type=script&lang=js"

import "./OneTab.vue?vue&type=style&index=0&id=0a761cf5&scoped=true&lang=css"

import exportComponent from "D:\\Pranav\\Coding\\MyProjects\\Own Projects\\todo_list_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a761cf5"]])

export default __exports__